module.exports = __webpack_public_path__ + "static/media/karnataka-government-logo.12992bf5.jpg";